import * as mutation_types from "./mutation_types";

export default {
    [mutation_types.M_SET_SEARCHED](state, payload) {
        state.searched = payload;
    },
    [mutation_types.M_SET_SEARCH_IN_OUT](state, payload) {
        state.searchInOut = payload;
    },
    [mutation_types.M_SET_MIN_PRICE](state, payload) {
        state.minPrice = payload;
    },
    [mutation_types.M_MAX_PRICE_IS_SET](state, payload) {
        state.maxPriceIsSet = payload;
    },
    [mutation_types.M_SET_OUT_HOTEL_MIN_PRICE](state, payload) {
        state.outHotelMinPrice = payload;
    },
    [mutation_types.M_SET_API_URL](state, payload) {
        state.API_URL = payload;
    },
    [mutation_types.M_SET_API_ORIGIN](state, payload) {
        state.API_ORIGIN = payload;
    },
    [mutation_types.M_SET_LAST_MAP_REQUEST](state, payload) {
        state.lastMapRequest = payload;
    },
    [mutation_types.M_SET_HOTELS_FOR_MAP](state, payload) {
        if (payload.type === 0) {
            state.mapItems = [...payload.items]
        } else {
            state.mapItems = [...state.mapItems, ...payload.items]
        }
    },
    [mutation_types.M_COLLAPSE_BY_HOTEL](state, payload) {
        state.collpse = payload;
    },
    [mutation_types.M_SET_SHOW_TOUR_RESULT_LIST](state, payload) {
      state.showTourResultList = payload;
    },
    [mutation_types.M_SET_SEARCH_LOADER_STATUS](state, payload) {
      state.searchLoaderStatus = payload;
    },
    [mutation_types.M_SET_ON_MOUNTED_CHANGE_DAYS_FLAG](state, payload) {
      state.onMountedChangeDaysFlag = payload;
    },
    [mutation_types.M_SET_SEARCH_SECOND_PARAMS_COUNTER](state, payload) {
        state.searchSecondParamsCounter = payload
    },
    [mutation_types.M_SET_FIRST_SEARCH](state, payload) {
        state.firstSearch = payload
    },
    [mutation_types.M_SET_FIRST_SEARCH_WITH_PARAMS](state, payload) {
        state.firstSearchWithParams = payload
    },
    [mutation_types.M_SET_CLICK_SEARCH](state, payload) {
        state.clickSearch = payload
    },
    [mutation_types.M_SET_CONVERT_PRICE_FLAG](state, payload) {
        state.convertPriceFlag = payload
    },
    [mutation_types.M_SET_HOTEL_QUOTA_FOR_HOTELS](state, payload) {
        state.filterParams.hotelQuota = payload
    },
    [mutation_types.M_SET_AVIA_QUOTA](state, payload) {
        state.filterParams.aviaQuota = payload
    },
    [mutation_types.M_SET_BUS_QUOTA](state, payload) {
       state.filterParams.busTransferQuota = payload
    },
    [mutation_types.M_SET_RAILWAY_QUOTA](state, payload) {
        state.filterParams.railwayTransferQuota = payload
    },
    [mutation_types.M_SET_FILTER_PARAMS](state, payload) {
      state.filterParams = payload
    },
    [mutation_types.M_SET_CHECK_FILTER_SELECT](state, payload) {
        state.checkFilterSelect = payload
    }
};
